export class AccentService {

    constructor(private readonly accentMap: {[key: string]: string}) {}

    public normalize(string: string): string {
        let normalizedString = '';

        for (let i = 0; i < string.length; i++) {
            normalizedString += this.accentMap[string.charAt(i)] || string.charAt(i);
        }

        return normalizedString;
    }

}